

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function UserRegistrationsPage() {
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (token && userId) {
            fetchUserRegistrations(userId);
        } else {
            console.log("لم يتم العثور على التوكن أو userId.");
            setLoading(false);
        }
    }, []);

    const fetchUserRegistrations = async (userId) => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`https://localhost:7136/api/registrations/user/${userId}`);
            if (response.status === 200) {
                setRegistrations(response.data);
                setLoading(false);
            } else if (response.status === 400) {
                console.error("Invalid User ID.");
                setError("Invalid User ID.");
                setLoading(false);
            } else if (response.status === 404) {
                setRegistrations([]);
                setLoading(false);
            } else {
                console.error("Error fetching user registrations:", response.status);
                setError("حدث خطأ أثناء جلب تسجيلات المستخدم.");
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching user registrations:", error);
            setError("حدث خطأ غير متوقع أثناء جلب تسجيلات المستخدم.");
            setLoading(false);
        }
    };

    const handleCancelRegistration = async (eventId) => {
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');

        if (!token || !userId) {
            console.log("يجب تسجيل الدخول لإلغاء الحجز.");
            return;
        }

        try {
            const response = await axios.delete('https://localhost:7136/api/registrations/cancel-register', { data: { userId, eventId } });
            if (response.status === 204) {
                alert("تم إلغاء حجزك بنجاح.");
                fetchUserRegistrations(userId);
            } else if (response.status === 404) {
                alert("لم يتم العثور على هذا التسجيل.");
            } else {
                alert("حدث خطأ أثناء محاولة إلغاء الحجز.");
            }
        } catch (error) {
            console.error("Error cancelling registration:", error);
            alert("حدث خطأ غير متوقع أثناء محاولة إلغاء الحجز.");
            if (error.response) {
                console.log(error.response.data);
            }
        }
    };

    if (loading) {
        return <div className="min-h-screen bg-gray-100 flex items-center justify-center">جاري التحميل...</div>;
    }

    if (error) {
        return <div className="min-h-screen bg-gray-100 flex items-center justify-center text-red-500">{error}</div>;
    }

    return (

        
<div
      className="min-h-screen bg-cover bg-center p-8"
      style={{ backgroundImage: `url('./images/photo15.jpg')` }}
    >            <div className="container mx-auto">
<h1 className="text-3xl font-bold mb-6 text-black">تسجيلاتي في الفعاليات</h1>{registrations.length > 0 ? (
    <div className="shadow-md rounded-lg overflow-x-auto">
    <div className="grid grid-cols-7 gap-4 p-4 bg-gray-700 text-white rounded-t-lg"> {/* خلفية أغمق ونص أبيض للرأس */}
        <div className="font-semibold">عنوان الفعالية</div>
        <div className="font-semibold">المكان</div>
        <div className="font-semibold">تاريخ الفعالية</div>
        <div className="font-semibold">سعر التذكرة</div>
        <div className="font-semibold">حالة الدفع</div>
        <div className="font-semibold">تاريخ التسجيل</div>
        <div className="font-semibold text-center">إلغاء</div>
    </div>
    {registrations.map((registration) => (
        <div
            key={registration.registrationId}
            className="grid grid-cols-7 gap-4 p-4 border-b border-gray-200 bg-white/80" // خلفية بيضاء شبه شفافة للصفوف
        >
            <div className="text-gray-900">{registration.event?.title}</div> {/* نص أغمق */}
            <div className="text-gray-900">{registration.event?.venue}</div>
            <div className="text-gray-900">{registration.event?.eventDatetime ? new Date(registration.event.eventDatetime).toLocaleDateString() : '-'}</div>
            <div className="text-gray-900">{registration.event?.ticketPrice} EGP</div>
            <div className={`font-semibold ${registration.paymentStatus === 'Paid' ? 'text-green-500' : 'text-yellow-500'} text-gray-900`}>{registration.paymentStatus}</div> {/* نص أغمق لحالة الدفع */}
            <div className="text-gray-900">{new Date(registration.registrationDate).toLocaleDateString()}</div>
            <div className="text-center">
                <button
                    onClick={() => handleCancelRegistration(registration.event?.eventId)}
                    className="inline-flex items-center bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
                >
                    إلغاء الحجز
                </button>
            </div>
        </div>
    ))}
</div>

                ) : (
                    <div className="text-center py-8">
        <p className="text-black font-bold text-lg">لم تقم بالتسجيل في أي فعالية حتى الآن.</p> {/* تم تغيير اللون إلى الأسود والخط إلى عريض */}
        </div>
                )}
            </div>
        </div>
    );
}

export default UserRegistrationsPage;



